import './main.scss';
import.meta.glob(["./javascript/**/*.js", "./components/**/*.js"], { eager: true });
